import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysLoading from "@/features/system-states/sys-loading";

export default function LoadingPage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-00")}>
      <SysLoading />
    </SystemStatePage>
  );
}
